export class Variation {
    public title: string;
    public acceleration: number;
}
